export default __webpack_public_path__ + "assets/SK0006U_SALTAD_tracking.65625a72.gif";